import React from "react";
import styled from "styled-components";

const InputSearch = React.forwardRef((props, ref) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        ...props.parentStyle,
      }}
    >
      <InputWrapper
        ref={ref}
        id={props.id ? props.id : "inputSearch"}
        value={props.value}
        onChange={(e) => {
          props.onChange(e.target.value);
        }}
        type={props.type}
        placeholder={props.placeholder}
        style={{
          ...props.style,
        }}
        onKeyDown={props.onKeyDown}
        onCompositionEnd={props.onCompositionEnd}
      />

      <img
        onClick={() => {
          props.setDataToKeyword();
        }}
        src="/assets/icons/search.png"
        alt=""
        style={{
          position: "absolute",
          top: "12px",
          right: "16px",
          width: 16,
          height: 16,
          cursor: "pointer",
          ...props.searchStyle,
        }}
      />
    </div>
  );
});

export default InputSearch;

const InputWrapper = styled.input.attrs((props) => {})`
  width: 100%;
  height: 42px;
  border-radius: 8px;
  padding: 10px 16px;
  background: #f6f7f8;
  border: 1px solid #f6f7f8;

  font-family: "LINESeedKR-Rg";
  color: #101113;
  font-weight: 400;
  font-size: 16px;
  line-height: 22.4px;

  &:focus {
    outline: 1px solid #0000c7;
  }

  &::placeholder {
    color: #575b65;
    font-weight: 400;
    font-size: 16px;
    line-height: 22.4px;
  }
`;
